import { createContentPropTypes } from '../../../helpers/content';

const content = {
	paymentTypeLabel: 'Type',
	fromLabel: 'From',
	bacsIdLabel: 'Bacs ID',
	submissionDateLabel: 'Submission date',
	settlementDateLabel: 'Settlement date',
	numberOfPaymentsLabel: 'Individual payments',
	totalAmountLabel: 'Total amount',
	toLabel: 'To',
	amountLabel: 'Amount',
	referenceLabel: 'Reference',
	transactionCodeLabel: 'Transaction code',
	collectionDateLabel: 'Collection date',
};

export const contentPropTypes = createContentPropTypes(content);

export default content;
